// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bg-0";
export var headerCellHover = "_bg-1";
export var readCellContainer = "_bg-2";
export var readCellSlot = "_bg-3";
export var rowHoverCheckbox = "_bg-4";
export var rowUnreadIndicator = "_bg-5";
export var searchHighlight = "_bg-8";
export var supportTicketRow = "_bg-6";
export var unreadIndicator = "_bg-7";